<template>
  <div v-if="issue && issue.id && extraFields && extraFields.length" class="extrafield-container row">
    <h4> {{ $t('common.extra_fields') }}</h4>
    <div v-if="issue.active" class="custom-control-vuvle custom-control custom-switch">
      <input id="editEFMode" v-model="editMode" type="checkbox" class="custom-control-input" @click="toggleEdit">
      <label class="custom-control-label" for="editEFMode">{{ $t('action.edit') }}</label>
    </div>

    <div class="container-fluid">
      <div v-for="(extraField, index) in extraFields" :key="index" data-toggle="tooltip" data-placement="top" :title="extraField.description" class="row">
        <div v-if="!editMode || (!superUser && extraField.writePermissions !== 'EMPLOYEES')" class="col-md-4">
          {{extraField.name}}
        </div>

        <div v-if="editMode && extraField.type !== 'MULTIVALUE' && (superUser || extraField.writePermissions === 'EMPLOYEES')" class="col-12 input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text">{{extraField.name}}</span>
          </div>
          <textarea v-if="extraField.type === 'TEXTAREA'" v-model="issueValues[extraField.id]" :placeholder="'Ingrese '+extraField.name" class="form-control" :class="issueValues.class && issueValues.class[extraField.id]" />
          <input v-else-if="extraField.type === 'STRING'" v-model="issueValues[extraField.id]" :placeholder="'Ingrese '+extraField.name" type="text" class="form-control" :class="issueValues.class && issueValues.class[extraField.id]">
          <input v-else-if="extraField.type === 'NUMBER'" v-model="issueValues[extraField.id]" :placeholder="'Ingrese '+extraField.name" type="number" class="form-control" :class="issueValues.class && issueValues.class[extraField.id]">
          <select v-else-if="extraField.type === 'SELECT'" v-model="issueValues[extraField.id]" class="form-control form-select" :class="issueValues.class && issueValues.class[extraField.id]">
            <option v-for="(option, index1) in extraField.extraFieldOptions" :key="index1" :value="option.value">
              {{ option.name }}
            </option>
          </select>
          <div v-else-if="extraField.type === 'BOOLEAN'" class="form-control">
            <input v-model="issueValues[extraField.id]" type="checkbox">
            <span v-if="issueValues.class && issueValues.class[extraField.id]==='is-valid'" class="ml-2" style="font-size:13px;color:green;">Su cambio fué guardado</span>
            <span v-else-if="issueValues.class && issueValues.class[extraField.id]==='is-invalid'" class="ml-2" style="font-size:13px;color:red;">Sin Permisos</span>
            <span class="d-none d-md-inline" style="font-size:14px;float:right;"> ← {{ $t('message.bool_warning') }}</span>
          </div>

          <div v-if="extraField.type !== 'BOOLEAN' && issueValues.class && issueValues.class[extraField.id]==='is-invalid'" style="position:absolute;right:25%;bottom:25%;">
            <span class="ml-2" style="font-size:13px;color:red;">{{ $t('message.no_permissions') }}</span>
          </div>

          <div class="input-group-append">
            <button class="btn btn-outline-success" type="button" @click="saveEFV(extraField)">
              {{ $t('action.save') }}
            </button>
          </div>
        </div>
        <div v-else-if="editMode && extraField.type === 'MULTIVALUE' && (superUser || extraField.writePermissions === 'EMPLOYEES')" class="col-12 mb-2 mt-2">
          <div class="list-group-item list-group-item-action justify-content-between align-items-center active">
            {{extraField.name}}
          </div>
          <a v-for="(value, index1) in issueValues[extraField.id]" :key="index1" class="list-group-item list-group-item-action">
            <b>{{ formatDate(value.dateSetted) }}</b> - {{value.value}}
          </a>

          <div class="list-group-item list-group-item-action">
            <div class="input-group">
              <div class="input-group-prepend">
                <button class="btn btn-outline-success" type="button" @click="addValue(extraField)">
                  +
                </button>
              </div>
              <input v-model="newValue[extraField.id]" type="text" :placeholder="'Ingrese nuevo ' + extraField.name" class="form-control">
            </div>
          </div>
        </div>
        <div v-else-if="extraField.type === 'BOOLEAN'" class="mb-1">
          <span v-if="issueValues[extraField.id]">✓</span>
          <span v-else>✗</span>
        </div>
        <div v-else-if="extraField.type === 'MULTIVALUE'" class="col-md-8 mb-1">
          <div v-for="(value, index1) in issueValues[extraField.id]" :key="index1" class="row">
            <span><b>{{ formatDate(value.dateSetted, true) }}</b> - Dijo {{value.username}}: "<i>{{ value.value }}</i>"</span>
          </div>
        </div>
        <div v-else class="mb-1">
          {{ issueValues[extraField.id] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExtraFieldService from '@/services/extrafield.service';
import { formatDate } from '@/utils/page-utils';

export default {
    name: 'IssueExtraField',
    props: {
        issue: Object,
        superUser: Boolean
    },
    data() {
        return {
            extraFields: [],
            issueValues: {
                class: {}
            },
            newValue: {},
            editMode: false
        };
    },
    created() {
        this.issueProcessing = this.issue;
        this.initEFComponent();
    },
    updated() {
        // avoid looping
        if (!this.issueProcessing || this.issueProcessing.id !== this.issue.id) {
            this.issueProcessing = this.issue;
            this.initEFComponent();
        }
    },
    methods: {
        initEFComponent() {
            this.editMode = false;
            // reset issue values.
            this.issueValues = {
                class: {}
            };
            // MAYBE, just MAYBE todo, extraFields could be implemented in the IssuesList, then trailed here
            this.getExtraFields();
            // getExtraFields is getting the issueValues also, I would recommend to split those, like before.
            // this.getIssueValues();
        },
        formatDate,
        toggleEdit() {
            this.editMode = !this.editMode;
        },
        getExtraFields() {
            const self = this;
            ExtraFieldService.getExtraFields(true).then(
                response => {
                    ExtraFieldService.getIssueExtraFieldVals(this.issue.id).then(
                        response1 => {
                            self.extraFields = response.data;
                            response1.data.forEach(function eachExtraFieldValue(efv) {
                                if (efv.extrafield.type === 'MULTIVALUE') {
                                    self.issueValues[efv.extrafield.id] = efv.values;
                                } else if (efv.extrafield.type === 'BOOLEAN') {
                                    self.issueValues[efv.extrafield.id] = efv.value === 'true';
                                } else {
                                    // customization for smartdrone
                                    if (efv.extrafield.name === 'Accesorios') {
                                        self.issue.accesorios = 'Accesorios: ' + efv.value;
                                    }
                                    self.issueValues[efv.extrafield.id] = efv.value;
                                }
                            });
                        },
                        error1 => {
                            console.log(error1.response && error1.response.data ||
                      error1.message || error1.toString());
                        }
                    );
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        addValue(extraField) {
            var self = this;
            var data = {
                value: this.newValue[extraField.id]
            };
            if (data.value.length) {
                ExtraFieldService.addValueToMultival(extraField.id, this.issue.id, data).then(
                    response => {
                        self.newValue[extraField.id] = '';
                        self.getExtraFields();
                    },
                    error => {
                        if (error.response.status === 403) {
                            self.newValue[extraField.id] = 'No tienes permiso para agregar.';
                            self.getExtraFields();
                        }
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );
            }
        },
        saveExtraFields() {
            var self = this;
            this.extraFields.forEach(function eachExtraField(efv) {
                if (efv.type !== 'MULTIVALUE') {
                    self.saveEFV(efv);
                }
            });
        },
        // removeValue() {
        //     alert('no está implementado');
        // },
        saveEFV(extraField) {
            var data = {
                extrafield: extraField,
                value: this.issueValues[extraField.id]
            };
            var self = this;

            self.issueValues.class = {};
            ExtraFieldService.saveExtraFieldValue(this.issue.id, data).then(
                response => {
                    self.getExtraFields();
                    self.issueValues.class[extraField.id] = 'is-valid';
                },
                error => {
                    if (error.response.status === 403) {
                        self.getExtraFields();
                        self.issueValues.class[extraField.id] = 'is-invalid';
                    }
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        }
    /* eslint-disable no-console */
    }
};
</script>
<style lang="scss">
.remove-info {
    right: 15px;
    position: absolute;
    font-size: 15px;
}
.custom-control-vuvle {
    position: absolute;
    right: 100px;
    line-height: 1.7;
    transform: scale(1.25);
    -webkit-transform: scale(1.25);
    max-width: 50%;
    text-align: right;
    .custom-control-label {
        font-size: 14px;
    }
    @media(max-width: 600px) {
        width: 100%;
        position: relative;
        text-align: right;
        right: 15%;
    }
}
.extrafield-container {
    h4 {
        margin-left: 15px;
    }
    @media(max-width: 600px) {
        .input-group.mb-1 {
            margin-bottom: 10px!important;
            .input-group-prepend {
                width: 100%;
                .input-group-text {
                    width: 100%;
                }
            }
        }
    }
}
</style>
